import './Button.scss';

class Button {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log()
  }

}

JSModules['Button'] = Button;
export default Button;
